(function () {
    'use strict';

	/*
	 ProductDetailsDialogController
	-------------------------------------------------------------------------- */

    angular
        .module('PublicApp.productDetailsDialog', [])
        .controller('ProductDetailsDialogController', [
            '$scope',
            '__DataStore',
            'appServices',
            '$stateParams',
            '__Form',
            '__Utils',
            '$q',
            'GetProductDetails',
            '$compile',
            '$rootScope',
            '__Auth',
            ProductDetailsDialogController
        ]);

	/**
	 * ProductDetailsDialogController for product details application
	 * 
	 * @inject $scope
	 * @inject __DataStore
	 * @inject appServices
	 * @inject $stateParams
	 * @inject __Form
	 * @inject __Utils
	 * 
	 * @return void
	 *-------------------------------------------------------- */

    function ProductDetailsDialogController($scope, __DataStore, appServices,
        $stateParams, __Form, __Utils, $q, GetProductDetails, $compile, $rootScope, __Auth) {

        var scope = this;

        scope.categoryID = $scope.ngDialogData.categoryID;
        scope.productID = $scope.ngDialogData.productID;
        scope.pageType = $scope.ngDialogData.pageType;
        scope.dialogStatus = $scope.ngDialogData.dialogStatus;
        scope.isLoggedIn = __Auth.isLoggedIn();

        __Auth.refresh(function (authInfo) {
            scope.auth_info = authInfo;
        });

        scope = __Form.setup(scope, 'add_product_in_cart_form', 'productData', {
            modelUpdateWatcher: false
        });

        scope.pageStatus = false;
        scope.optionLength = false;

        //add product compare function start
        scope.addProductCompare = function (productId) {

            __DataStore.post({
                'apiURL': 'product.compare.add',
                'productId': productId
            }, scope).success(function (responseData) {

                var requestData = responseData.data;
                appServices.processResponse(responseData, null, function (reactionCode) {
                    if (reactionCode == 1) {
                        scope.productDetails.addedInCompareList = true;
                        var countCompareProduct = requestData.countCompareProduct;
                        $scope.$emit('lw.product.compare.count', true);
                    }

                });

            });
        }
        //add product compare function end

        //remove product compare function start
        scope.removeProductCompare = function (productId) {
            __DataStore.post({
                'apiURL': 'product.compare.remove',
                'productId': productId
            }, scope).success(function (responseData) {
                var requestData = responseData.data;
                appServices.processResponse(responseData, null, function (reactionCode) {

                    if (reactionCode == 1) {
                        scope.productDetails.addedInCompareList = false;
                        var countCompareProduct = requestData.countCompareProduct;
                        $scope.$emit('lw.product.compare.count', true);
                    }
                });

            });
        }
        //remove product compare function end


        var requestData = GetProductDetails.data.details;

        scope.itemRating = requestData.itemRating;
        scope.productStatus = requestData.productStatus;
        scope.enableRating = requestData.enableRating;
        scope.enableRatingReview = requestData.enableRatingReview;
        scope.restrictAddRating = requestData.restrictAddRating;
        scope.enableRatingModification = requestData.enableRatingModification;
        scope.isPurchsedProduct = requestData.isPurchsedProduct;
        scope.isAddedInWishlist = requestData.isAddedInWishlist;
        scope.productSpecExists = requestData.productSpecExists;
        scope.productDetails = requestData;
        scope.launchingDate = requestData.launchingDate;
        scope.images = requestData.allImages;
        scope.defaultImages = requestData.defaultImages;
        scope.primaryImages = requestData.primaryImages;
        scope.isEnableReating = function () {

            scope.isEnableRatingModification = true;

            // this condition check used for enable rating modification
            if (_.isEmpty(scope.itemRating.selfRating)
                && scope.enableRatingModification == false) {

                scope.isEnableRatingModification = false;

            } else if (!_.isEmpty(scope.itemRating.selfRating)
                && scope.enableRatingModification == true) {

                scope.isEnableRatingModification = false;

            } else if (_.isEmpty(scope.itemRating.selfRating)
                && scope.enableRatingModification == true) {

                scope.isEnableRatingModification = false;

            } else if (scope.restrictAddRating == true
                && scope.enableRatingModification == true) {

                scope.isEnableRatingModification = true;
            }

            if (scope.restrictAddRating == true
                && scope.isPurchsedProduct == false) {

                scope.isEnableRatingModification = true;
            }

        };
        scope.isEnableReating();

        if (scope.enableRatingModification == true && scope.productStatus != 1) {

            scope.isEnableRatingModification = true;
        }

        //product rating bar start
        _.delay(function () {
            $(function () {
                $('#lw-bar-rating').barrating('show', {
                    theme: 'fontawesome-stars-o',
                    showValues: false,
                    allowEmpty: false,
                    readonly: scope.isEnableRatingModification,
                    initialRating: scope.itemRating.selfRating,
                    onSelect: function (value, text, event) {
                        if (typeof (event) !== 'undefined') {
                            // rating was selected by a user
                            // console.log(value);
                            if (!window.__appImmutables.auth_info.authorized) {
                                appServices.loginRequiredDialog('login-dialog', null, function (promiseObj) {
                                    if (promiseObj == true) {
                                        scope.submitRatingAndReview(value);
                                    }
                                });
                                // appServices.showDialog({},
                                //     {
                                //         templateUrl : __globals.getTemplateURL('user.login-dialog')
                                //     },
                                // function(promiseObj) {
                                //     if (promiseObj.value.login_success == true) {
                                //         scope.submitRatingAndReview(value);
                                //     }
                                // });

                            } else if (scope.enableRating == true) {
                                scope.submitRatingAndReview(value);
                            }
                        }
                    }
                });
            });
        }, 200);
        //product rating bar end  

        // hold product related categories data & make comma Separate
        scope.productDetails.categories = requestData.categories;

        scope.productDetails.basePriceWithAddonPrice = requestData.newTotalPrice;

        scope.productDiscount = requestData.productDiscount;

        $scope.$on('ngDialog.opened', function (e, $dialog) {
            var $discount = $compile(__Utils.template('#discountDetailsTemplate', scope.productDiscount))(scope);
            scope.discountDetailsHtml = $discount.html();
        });


        //__pr($discount);
        //scope.discountDetailsHtml = $discount.html();

        scope.newTotalPriceCount = requestData.newTotalPriceCount;

        scope.productDetails.selectedOptions = requestData.getSelectedOptions;

        scope.oldPrice = scope.productDetails.old_price;

        if (scope.productDetails) {
            scope.productData.name = requestData.name;
        }

        if (!_.isEmpty(scope.productDetails.selectedOptions)) {
            scope.optionLength = true;
        }

        scope.productDetails.priceDetails = {
            'option': requestData.getSelectedOptions,
            'total': requestData.getPrice.total,
            'base_price': requestData.getPrice.base_price
        };

        // product quantity
        if (requestData.qtyCart > 0) {

            scope.productData.quantity = requestData.qtyCart;
            scope.checkNumber = true;

        } else {
            scope.productData.quantity = 1;
        }

        scope.btnQuantity = requestData.qtyCart;
        scope.productData.isCartExist = requestData.isCartExist;

        scope.pageStatus = true;

        /* _.delay(function() {
             $('#lwRateIt .rateit').bind('rated reset', function (e) {
                 e.preventDefault();
                 var ri = $(this);
                 var value = ri.rateit('value');               
             });
         }, 1000);*/


        /**
          * Submit rating action
          *
          * @return void
          *---------------------------------------------------------------- */
        scope.submitRatingAndReview = function (value) {

            if (!_.isEmpty(value)) {
                __DataStore.post({
                    'apiURL': 'product.rating.add',
                    'productId': scope.productID,
                    'rate': value
                }, scope).success(function (responseData) {

                    appServices.processResponse(responseData, null, function () {

                        scope.itemRating = responseData.data.itemRating;
                        scope.rating = parseFloat(scope.itemRating.rate);

                        // manage product list rating show dynamic start
                        var ratingElement = $('#lw-product-rating-' + scope.productID).length;

                        var decimal = '',
                            formatItemRating = '',
                            rated = Math.floor(scope.rating),
                            unrated = Math.floor(5 - rated);

                        if (scope.rating % 1 != 0) {
                            decimal = '<i class="fa fa-star-half-o lw-color-gold"></i>';
                            unrated = unrated - 1;
                        }

                        //create format string
                        formatItemRating = (_.repeat('<i class="fa fa-star lw-color-gold"></i>', rated) +
                            decimal +
                            _.repeat('<i class="fa fa-star lw-color-gray"></i>', unrated));

                        //check item rating null or not
                        if (ratingElement > 0) {

                            var element = $('#lw-product-rating-' + scope.productID).html("");

                            string = '<span class="lw-product-rating-avg border">' + formatItemRating + '</span><span class="text-muted">' + scope.itemRating.rate + '<small>(' + scope.itemRating.totalVotes + ')</small></span>';

                            $(element).html(string);

                        } else if (ratingElement == 0) {

                            var element = $('#lw-product-star-rating-' + scope.productID).html(""),

                                string = '<div id="lw-product-rating-' + scope.productID + '"><span class="lw-product-rating-avg border">' + formatItemRating + '</span><span class="text-muted">' + scope.itemRating.rate + '<small>(' + scope.itemRating.totalVotes + ')</small></span></div>';

                            $(element).html(string);
                        }
                        // manage product list rating show dynamic end

                        // if is allow for review
                        if (scope.itemRating.showDialog === true) {
                            scope.showAddReviewDialog(responseData.data);
                        }

                        scope.isEnableReating();

                    });

                });
            }
        };

        /**
          * Show user login dialog
          *
          * @return void
          *---------------------------------------------------------------- */

        scope.showAddReviewDialog = function (responseData) {

            appServices.showDialog({
                'reviewData': responseData,
                'productId': scope.productID
            },
                {
                    templateUrl: __globals.getTemplateURL('product.add-review-dialog'),
                    controller: "AddReviewDialogController as AddReviewDialogCtrl",
                    resolve: {
                        GetReviewData: function () {

                            //create a differed object          
                            var defferedObject = $q.defer();

                            __DataStore.fetch({
                                'apiURL': 'product.review.support.data',
                                'productId': scope.productID
                            }).success(function (responseData) {

                                appServices.processResponse(responseData, null, function (reactionCode) {

                                    //this method calls when the require        
                                    //work has completed successfully        
                                    //and results are returned to client        
                                    defferedObject.resolve(responseData);

                                });

                            });

                            //return promise to caller          
                            return defferedObject.promise;
                        }
                    }
                },
                function (promiseObj) {

                });

        };

        /**
          * Show Ratings of this item
          *
          * @return void
          *---------------------------------------------------------------- */

        scope.showRatingAndReviews = function () {

            appServices.showDialog({
                'itemTitle': scope.productData.name
            },
                {
                    templateUrl: __globals.getTemplateURL('product.ratings-and-reviews-dialog'),
                    controller: "ItemRatingAndReviewDialogController as RatingAndReviewCtrl",
                    resolve: {
                        GetRatingAndReviewData: function () {

                            //create a differed object          
                            var defferedObject = $q.defer();

                            __DataStore.fetch({
                                'apiURL': 'product.rating_review.get_support_data',
                                'productId': scope.productID
                            }).success(function (responseData) {

                                appServices.processResponse(responseData, null, function (reactionCode) {

                                    //this method calls when the require        
                                    //work has completed successfully        
                                    //and results are returned to client        
                                    defferedObject.resolve(responseData);

                                });

                            });

                            //return promise to caller          
                            return defferedObject.promise;
                        }
                    }
                },
                function (promiseObj) {

                });
        };

        /**
       * Take product quantity action.
       *
       * @param {Number} status
       * @param {Number} qty
       * @return void
       *
       *------------------------------------------------------------------------ */

        scope.getQtyAction = function (status, quantity) {

            // if product status is true 
            if (status == true) {
                (quantity == undefined || isNaN(quantity))
                    ? scope.productData.quantity = 1
                    : scope.productData.quantity = quantity + 1;

            } else {
                // product quantity must be greterThan -1
                var newValue = (quantity - 1);
                (newValue <= 0)
                    ? scope.productData.quantity = 1
                    : scope.productData.quantity = newValue;
            }

        };

        /**
          * Add product as a cart item
          *
          * @return void
          *---------------------------------------------------------------- */
        scope.cartAction = false;

        scope.addToCart = function () {

            __Form.process({
                apiURL: 'cart.add.item',
                productID: scope.productID
            }, scope).success(function (responseData) {

                scope.cartAction = true;

                var requestData = responseData.data;

                appServices.processResponse(
                    responseData,
                    null,
                    function () {

                        scope.data = {
                            'cart_string': responseData.data.cartItems,
                            'status': true
                        }
                        scope.updateCartItem(scope.productID, true);
                        $scope.$emit('lw.update.cart.string', scope.data);
                    }
                );

            });
        };

        /**
          * Add to Wish-list
          *
          * @return void
          *---------------------------------------------------------------- */
        scope.addToWishlist = function () {

            if (!window.__appImmutables.auth_info.authorized) {

                appServices.loginRequiredDialog('login-dialog', null, function (result) { });

            } else {
                __DataStore.post({
                    'apiURL': 'product.wishlist.add_process',
                    'productId': scope.productID
                }, scope).success(function (responseData) {
                    var requestData = responseData.data;
                    if (requestData.showLoggedInDialog) {
                        appServices.loginRequiredDialog('login-dialog', null, function (result) { });
                    }
                    appServices.processResponse(responseData, null, function (reactionCode) {
                        if (reactionCode == 1) {
                            $('.lw-remove-wishlist-' + scope.productID).show();
                            $('.lw-add-wishlist-' + scope.productID).hide();

                            scope.isAddedInWishlist = true;
                        }
                    });
                });
            }

        };

        /**
          * Remove from Wish-list
          *
          * @return void
          *---------------------------------------------------------------- */
        scope.removeFromWishlist = function () {
            __DataStore.post({
                'apiURL': 'product.wishlist.remove_process',
                'productId': scope.productID
            }, scope).success(function (responseData) {
                var requestData = responseData.data;
                if (requestData.showLoggedInDialog) {
                    appServices.loginRequiredDialog('login-dialog', null, function (result) { });
                }

                appServices.processResponse(responseData, null, function (reactionCode) {

                    if (reactionCode == 1) {
                        $('.lw-add-wishlist-' + scope.productID).show();
                        $('.lw-remove-wishlist-' + scope.productID).hide();
                        scope.isAddedInWishlist = false;
                    }
                });
            });
        };

        /**
          * Add product as a cart item
          *
          * @return void
          *---------------------------------------------------------------- */

        scope.updateCartItem = function (productID, option) {

            var checkOption = true;

            scope.addonPrices = [];

            if (scope.productData.options != undefined) {
                // hold option of addon_price related data 
                scope.productDetails.selectedOptions = scope.productData.options[productID];
                angular.forEach(scope.productData.options[productID],
                    function (value, key) {
                        this.push({
                            option_name: key,
                            value_name: value.name,
                            addon_price: value.addon_price_format
                        });
                    }, scope.addonPrices);

                // hold empty options data 
                angular.forEach(scope.productData.options[productID],
                    function (value, key) {

                        if (value == '') {
                            checkOption = false;
                        }

                    }, checkOption);
            }

            var selectedOptions = _.pluck(scope.productDetails.selectedOptions, 'id');

            var counter = 0,
                optionProductImages = [];

            _.forEach(selectedOptions, function (item) {
                _.forEach(scope.images, function (row, index) {
                    if (item === row.product_option_values_id) {
                        counter++;
                        row.counter = counter;
                        optionProductImages.push(row);
                    }
                });
            });

            if (optionProductImages.length > 0) {

                angular.element('.lw-main-slider-container').replaceWith($compile(__Utils.template('#lwMainSliderRow', {
                    'images': optionProductImages,
                    'firstImage': _.get(optionProductImages, 0)
                }))($scope));

                //scope.prepareZoomImage();

            } else if (optionProductImages.length == 0) {

                angular.element('.lw-main-slider-container').replaceWith($compile(__Utils.template('#lwMainSliderRow', {
                    'images': scope.defaultImages,
                    'firstImage': _.get(scope.defaultImages, 0)
                }))($scope));

                //scope.prepareZoomImage();
            }

            __Form.process({
                apiURL: 'cart.product.qty.update',
                productID: productID
            }, scope).success(function (responseData) {

                appServices.processResponse(
                    responseData,
                    null,
                    function (reactionCode) {

                        var requestData = responseData.data;

                        scope.productDetails.basePriceWithAddonPrice = requestData.totalPrice;
                        scope.productDetails.priceDetails = {
                            'option': scope.productDetails.selectedOptions,
                            'total': requestData.totalPrice,
                            'base_price': requestData.base_price
                        }

                        scope.productDiscount = requestData.productDiscount;

                        var $discount = $compile(__Utils.template('#discountDetailsTemplate', scope.productDiscount))(scope);
                        scope.discountDetailsHtml = $discount.html();

                        scope.productData.isCartExist = requestData.isCartExist;

                        if (requestData.qtyCart > 0) {
                            scope.productData.quantity = requestData.qtyCart;
                            scope.btnQuantity = requestData.qtyCart;
                        } else {
                            scope.btnQuantity = 0;
                            scope.productData.quantity = 1;
                        }
                    }
                );


            });

        };

        scope.previewImageUrl = '';
        scope.changeImage = function (imageUrl, e, index) {
            e.preventDefault();
            scope.currentImageIndex = index;
            scope.previewImageUrl = imageUrl;
            var triggerEl = document.querySelector('img.lw-zoom-image');
            $(triggerEl).attr('src', imageUrl);
            event.stopImmediatePropagation();
        }

        /**
    * open cart model
    *
    * @param object param1 type 
    *
    * @return void
    *---------------------------------------------------------------- */

        scope.openCartDialog = function (status) {
            $rootScope.$broadcast('lw.isCart.dialog', { dialog: status });

            //check if shopping cart dialog is open, if true then will not re-open again
            if (!($("html").hasClass("lw-shopping-cart-dialog-active"))) {

                $('html').addClass('lw-shopping-cart-dialog-active');

                appServices.showDialog(scope,
                    {
                        templateUrl: __globals.getTemplateURL('shoppingCart.cart-view')
                    },
                    function (promiseObj) {
                        $('html').removeClass('lw-shopping-cart-dialog-active');
                    });

                $rootScope.$on('ngDialog.opened', function (e, $dialog) {

                    if ($('div.lw-shopping-cart-dialog-content').length) {
                        $('div.ngdialog-content').addClass('lw-shopping-cart-dialog');
                    }

                });
            }
        };
    };

})();